import { Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Paper } from "@mui/material";
import XButton from "@/Washouts/assets/icons/X Button.svg";
import GetIconByAttachmentType from "../GetIconByAttachmentType";
import { TAttachmentType } from "@/Washouts/types/WashoutReview";

type TAttachedFilesListProps = {
	fileList: File[];
	setFileList: (fileList: File[]) => void;
};

const AttachedFilesList = (props: TAttachedFilesListProps) => {
	const { fileList, setFileList } = props;

	const handleRemove = (attachment: File) => setFileList(fileList.filter((i) => i !== attachment));

	return (
		<Grid container spacing={0.5} sx={{ padding: fileList?.length ? ".313rem .438rem" : 0 }}>
			{fileList?.map((attachment: File, index: number) => {
				const keyIndex = `file-attached-${index}`;
				const fileName = attachment.name;
				const fileExtension = fileName.split(".").pop() as TAttachmentType;
				return (
					<Grid item xs={6} key={keyIndex}>
						<Paper elevation={0} className="!bg-table-hover">
							<List dense disablePadding>
								<ListItem
									sx={{ paddingLeft: ".375rem" }}
									secondaryAction={
										<IconButton edge="end" aria-label="delete" onClick={() => handleRemove(attachment)}>
											<img src={XButton} style={{ width: ".75rem" }} />
										</IconButton>
									}
								>
									<ListItemIcon sx={{ minWidth: "1.5rem", marginRight: ".5rem" }}>
										<GetIconByAttachmentType type={fileExtension} />
									</ListItemIcon>
									<ListItemText
										className="text-default"
										primary={attachment.name}
										title={attachment.name}
										primaryTypographyProps={{
											sx: {
												whiteSpace: "nowrap",
												overflow: "hidden",
												textOverflow: "ellipsis",
												font: "400 .9em 'PTSansProNarrow', sans-serif",
												maxWidth: "100%",
											},
										}}
									/>
								</ListItem>
							</List>
						</Paper>
					</Grid>
				);
			})}
		</Grid>
	);
};

export default AttachedFilesList;
